export enum MessagesEN {
  ERR_BAD_RESPONSE = "Unexpected error",
  ERR_LOGIN = "Authentication error",
  ERR_BAD_REQUEST = "Authentication error",
  ERR_MEDIA_TYPE = "Invalid file type",
  GENERIC_ERROR = "Generic error",
  ERR_NOT_FOUND = "Nothing found",
  INVALID_PARAMS = "Invalid parameters",
  DONE_COURSE = "This course has already been completed",
  VALIDATION = "Field validation error",
  PERMISSION_DENIED = "Permission denied",
  FEEDBACK_UNAVAILABLE = "Feedback unavailable",
  
  // SIGN UP
  EXISTENT = "Email already exists",
  EMAIL_SUCCESS = "Email successfully sent",
  SIGNUP_SUCCESS = "Successfully registered user",

  // EDIT
  EDIT_SUCCESS = "Changes successfully saved",
  EDIT_ERROR = "Error saving changes",
  EXPIRED = "Session expired",
  EMAIL_ERROR = "Email error",
  NOT_FOUND = "Unexpected error",
  REQUIRED_FIELD = "Fill in the required fields",

  // USERS
  USER_ADDED = "New user successfully registered",
  USER_UPDATED = "User successfully edited",
  USER_STATUS = "Status changed successfully",
  USER_NOT_FOUND = "User not found",
  COURSE_NOT_FOUND = "Course not found",
  DATA_ERROR = "Generic error",
  ALREADY_EXISTS = "User already exists",
  INVALID_CPF = "Invalid CPF",
  UPLOAD = "Problems uploading file",
  CURRENT_PASSWORD_WRONG = "Current password is incorrect",
  PASSWORD_EDIT_SUCCESS = "Password changed successfully",
  ALREADY_ACTIVE = "User is already active",

  // COURSES
  COURSE_ADDED = "Course added successfully",
  COURSE_UPDATED = "Course updated successfully",
  COURSE_SENDED = "The course has been submitted for approval",
  COURSE_PUBLISHED = "The course has been published",
  COURSE_REPROVED = "The course has been rejected",
  CONNECTION_ERROR_COURSE_STATE = "Connection error",

  //CHAPTERS
  CHAPTER_ADDED = "The chapter has been added",
  CHAPTER_UPDATED = "The chapter has been updated",
  CHAPTER_NOT_DONE = "See all objectives to take the quiz",

  // ORGANIZATION
  ORGANIZATION_ADDED = "New organization successfully registered",
  ORGANIZATION_EDIT = "Organization successfully edited",

  //CATEGORIES
  CATEGORIE_DUPLICATED = "The category has already been added",

  //MATERIALS
  MATERIAL_ERROR = "Supplementary material is not allowed without at least one mandatory",
  MATERIAL_NOT_FOUND = "Material not found",
  MATERIAL_TYPE_ERROR = "Type of material is not allowed",
  MATERIAL_LIMIT_SIZE = "Exceeded file limit (450MB)",
  MATERIAL_ORDER = "Updated material order",
  MATERIAL_ORDER_ERROR = "You can only change the order of a material of the same classification",
  MEDIA_ERROR = "Error when deleting material",

  //QUIZ
  NOT_FOUND_QUIZ = "Quiz not found",
  HAS_CHECKED_QUESTION = "This question cannot be excluded",
  duration = "The duration must be up to 10 hours",
  QUIZ_ADDED = "The quiz information was successfully saved",

  //DRAG AND DROP
  RESPONSE_NOT_ADDED = "Responses weren't added to item. ",
  OPTIONS_LIMIT_EXCEEDED = "The number of options is limited to 5",
  LENGTH_ITEMS_REQUIRED = "The number of items must be between 3 to 5",

  //QUESTIONS
  QUESTION_BEING_USED = "The question cannot be deleted as it is already being used in another quiz",
  CSV_ERROR = "CSV file error",
  QUESTION_CREATED = "Question successfully created!",
  QUESTION_UPDATED = "Question successfully updated!",
  QUESTION_DELETED = "Question successfully deleted!",

  //TRUE_OR_FALSE_QUESTION
  LIMIT_ITEMS_TRUE_OR_FALSE = "The limit for question with true or false is 5",

  //DRAG_AND_DROP
  LIMIT_ITEMS_DRAG_AND_DROP = "The items number for this question type must be 3 or 5",

  //GAP
  LIMIT_ITEMS_GAP = "The items number for this question type must be 3 or 5",

  //FEEDBACK
  NODE_ALREADY_LIKED = "Error in feedback",

  //ATTENTION
  SETTINGS = "Changed settings",

  CSV_OBS = "Do not use a header in the import, just put information that will be imported",

  BLACKLIST_UPDATED = "Updated keywords.",

  //CLASSROOM
  CLASSROOM_STATUS_ACTIVE = "Class activated successfully.",
  CLASSROOM_STATUS_INACTIVE = "Class deactivated successfully.",

  //MEETING
  MEETING_CREATE_SUCCESS = "Event criated successfully.",
  MEETING_CREATE_ERROR = "Unable to add event.",

  //CSV ERRORS
  "Invalid Email Format" = "Email inválido",
  "Email duplicate" = "Email duplicate",

  //FORUM
  FORUM_UPLOAD_SIZE_ERROR = "Size of the file is too big (Maximum file size: 10mb).",
  FORUM_UPLOAD_TYPE_ERROR = "File type not allowed.",
  FORUM_TOPIC_SAVED = "Topic successfully saved.",
  FORUM_TOPIC_UPDATED = "Topic updated.",
  FORUM_COMMENT_SAVED = "Comment published.",
  FORUM_COMMENT_DELETED = "Comment deleted.",
  FORUM_COMMENT_DENOUNCED = "Comment successfully denounced.",
  TOPIC_MARKED_AS_RESOLVED = "Topic marked as resolved!",
  TOPIC_MARKED_AS_CLOSED = "Closed topic!",
  TOPIC_MARKED_AS_OPEN = "Reopened topic!",
  TOPIC_DELETED = "Deleted topic.",
  FORUM_COMMENT_UPDATED = "Updated comment.",
  TOPIC_DENOUNCE = "Topic reported succesfully.",
  DENOUNCED_TOPIC = "Can not update or delete topic due to denounces.",
  DENOUNCED_COMMENT = "Can not update or delete comment due to active denounces.",
  COMMENT_DISABLED = "This topic has been resolved or closed, comments are disabled.",
  FORUM_DENOUNCE_ACCEPTED = "Report(s) accepted.",
  FORUM_DENOUNCE_DISMISSED = "Report(s) dismissed.",

  //AGENDA
  EVENT_DELETED = "Event deleted",
  VIDEO_DOWNLOADED = "Video successfully downloaded!",
  COPIED_LINK = "Link copied successfully!",
  COPY_ERROR_LINK = "Error copying link.",
  DOWNLOAD_CLASS_ERROR = "Error downloading",

  //THEME
  THEME_LIMIT_IMAGE = "5 image limit exceeded.",
  CREATE_SUBDNS = "Subdomain already exists.",

  //LEAN MESSAGES
  STATUS_ASSESSMENT_SUCCCESS = "Assessment completed successfully.",
  STATUS_ASSESSMENT_ERROR = "Error while submitting assessment.",

  //ACTIVITIES
  ACTIVITY_CREATED = "Activity successfully created.",
  ACTIVITY_UPDATED = "Activity successfully updated.",
  ACTIVITY_DELETED = " Activity successfully deleted.",
  FEEDBACK_SUCCESS = "Activity successfully corrected.",
}
